export const BUSINESS = {
  name: "Amiri Roofing",
  phone: "204-963-9081",
  phoneHref: "tel:+12049639081",
  email: "amiriroofing@gmail.com",
  area: "Winnipeg & Surrounding Areas",
  province: "Manitoba, Canada",
};

export const IMAGES = {
  hero: "/images/roof-replacement-winnipeg-amiri-roofing.jpeg",
  hip: "/images/residential-roofing-winnipeg-homes.jpeg",
  crew: "/images/amiri-roofing-crew-winnipeg.jpeg",
  ridge: "/images/roof-repair-ridge-vents-winnipeg.jpeg",
  brown: "/images/shingle-roofing-winnipeg.jpeg",
};

export const SERVICES = [
  {
    id: "asphalt-shingles",
    num: "01",
    title: "Asphalt Shingle Roofing",
    short: "Architectural-grade shingles rated for prairie wind, hail and freeze-thaw cycles.",
    detail:
      "We install premium laminated architectural shingles with high-wind nailing patterns, ice-and-water shield at every eave and valley, and proper attic ventilation — the details that decide whether a roof survives a Manitoba winter or not.",
  },
  {
    id: "roof-replacement",
    num: "02",
    title: "Full Roof Replacement",
    short: "Complete tear-off and re-roof, done in days — not weeks.",
    detail:
      "From full tear-off to deck inspection, underlayment, flashing and final magnetic sweep, a replacement is a system rebuild. We document every layer with photos so you know exactly what's over your head.",
  },
  {
    id: "roof-repair",
    num: "03",
    title: "Roof Repair & Leak Response",
    short: "Fast leak diagnostics and permanent repairs — not tar-and-pray patches.",
    detail:
      "Missing shingles, lifted flashing, mystery stains on the ceiling — we trace leaks to the source, fix them properly, and tell you honestly whether a repair buys you years or just delays a replacement.",
  },
  {
    id: "storm-hail",
    num: "04",
    title: "Storm & Hail Damage",
    short: "Insurance-ready inspections and documentation after the storm hits.",
    detail:
      "Winnipeg hail doesn't ask permission. We provide photo-documented damage reports your insurer can actually use, emergency tarping when needed, and full restoration once the claim is approved.",
  },
  {
    id: "inspections",
    num: "05",
    title: "Inspections & Maintenance",
    short: "Seasonal check-ups that catch small problems before they become ceiling stains.",
    detail:
      "A fall inspection before freeze-up is the cheapest roof insurance you can buy. We check shingles, flashing, vents, valleys and attic ventilation, then give you a plain-language report.",
  },
  {
    id: "winter-damage",
    num: "06",
    title: "Ice Dam & Winter Damage",
    short: "Ice dam removal, prevention and the ventilation fixes that stop them for good.",
    detail:
      "Ice dams are a heat-loss symptom, not just a snow problem. We remove them safely, repair the damage, and fix the insulation and ventilation issues so they don't come back next January.",
  },
  {
    id: "gutter-cleaning",
    num: "07",
    title: "Gutter Cleaning & Eavestrough Care",
    short: "Seasonal eavestrough cleaning that keeps meltwater away from your foundation.",
    detail:
      "Clogged eavestroughs overflow straight down your walls and pool at your foundation — a leading cause of basement moisture in Winnipeg. We clear gutters and downspouts, flush the system, check hangers and slope, and flag any fascia or drip-edge damage we spot from the ladder. Ideal in late fall after the leaves drop and again in spring before the melt.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "They replaced our whole roof in two days, photographed every stage, and left the yard cleaner than they found it. Zero surprises on the invoice.",
    name: "Danielle P.",
    area: "River Heights",
  },
  {
    quote:
      "After the June hailstorm, Amiri documented everything for our claim and dealt with the adjuster directly. The new roof looks incredible.",
    name: "Mark & Susan T.",
    area: "St. Vital",
  },
  {
    quote:
      "Three companies quoted us. Amiri was the only one who actually went into the attic before giving a price. That told me everything.",
    name: "Gurpreet S.",
    area: "Transcona",
  },
];

export const SERVICE_PAGES = [
  {
    slug: "roof-repair-winnipeg",
    seoTitle: "Roof Repair Winnipeg | Leak & Shingle Repair — Amiri Roofing",
    seoDesc:
      "Fast, honest roof repair in Winnipeg: leak tracing, missing shingles, flashing and vent repairs, storm response. Every repair starts with a free photo-documented inspection. Call 204-963-9081.",
    overline: "Roof Repair — Winnipeg, MB",
    h1a: "Roof repair",
    h1b: "done right.",
    image: "ridge",
    imageAlt: "Repaired architectural shingle roof and ridge vents on a Winnipeg home",
    intro:
      "A roof leak never picks a convenient week. Whether it's a water stain creeping across the ceiling, shingles in the yard after a windstorm, or a drip you only notice during a chinook melt, the worst move is waiting. Small roof problems in Winnipeg become big ones fast — our freeze-thaw cycles force water into every gap it can find. We trace leaks to their actual source, fix them properly, and tell you honestly whether a repair buys you years or just delays the inevitable.",
    sections: [
      {
        h2: "Common roof repairs we handle in Winnipeg",
        body: "Most repair calls come down to a handful of culprits. Manitoba's temperature swings are hard on every roof component — especially the small ones nobody looks at:",
        list: [
          "Missing or wind-lifted shingles after prairie storms",
          "Active leaks traced to valleys, vents, or wall intersections",
          "Cracked plumbing vent boots — a classic -40°C casualty",
          "Lifted or rusted flashing around chimneys and skylights",
          "Ice dam damage along eaves and in valleys",
          "Animal damage from squirrels and raccoons at roof edges",
        ],
      },
      {
        h2: "Repair or replace? An honest framework",
        body: "Any roofer can sell you a new roof. Fewer will tell you when a $600 repair is all you need. Here's the same framework we use on every inspection:",
        list: [
          "Repair usually makes sense when the roof is under 15 years old, damage is isolated to one area, and the deck underneath is solid",
          "Replacement usually makes sense when leaks appear in multiple rooms, shingles are curling or losing granules across most slopes, or the roof is past 20 years",
          "Either way, you get photos of what we found — so the decision is yours, not ours",
        ],
      },
      {
        h2: "What a proper repair visit looks like",
        body: "We don't do tar-and-pray patches. A real repair starts with the attic, not the ladder: we check for daylight, moisture staining, and mould around the suspected area, then match the exterior damage to the interior evidence before touching a shingle. Repairs use matching materials where possible, and we document the before and after so you have records for resale or insurance.",
      },
    ],
  },
  {
    slug: "roof-replacement-winnipeg",
    seoTitle: "Roof Replacement Winnipeg | Full Tear-Off & Re-Roof — Amiri Roofing",
    seoDesc:
      "Full roof replacement in Winnipeg completed in 1–3 days: tear-off, deck inspection, ice-and-water shield, architectural shingles, magnetic clean-up. Free itemized quotes: 204-963-9081.",
    overline: "Roof Replacement — Winnipeg, MB",
    h1a: "A new roof,",
    h1b: "without the runaround.",
    image: "hero",
    imageAlt: "Completed full roof replacement with architectural shingles on a Winnipeg house",
    intro:
      "A roof replacement is the biggest maintenance investment most Winnipeg homeowners ever make — and the one with the most corners available to cut. The difference between a 12-year roof and a 25-year roof isn't the shingle brand. It's everything underneath: the tear-off, the deck, the underlayment, the flashing, the ventilation. We replace roofs as complete systems, and we photograph every layer so you know exactly what you paid for.",
    sections: [
      {
        h2: "What's included in a full Amiri replacement",
        body: "Every replacement quote we write covers the complete system — no vague allowances, no surprise extras on install day:",
        list: [
          "Full tear-off to the roof deck — we never roof over old shingles",
          "Deck inspection with soft or rotten wood replaced and photographed",
          "Ice-and-water shield at eaves, valleys, and penetrations, sized for Manitoba frost loads",
          "Synthetic underlayment across the full deck",
          "New flashing, drip edge, and vent boots — not reused old metal",
          "Architectural shingles with a six-nail high-wind pattern",
          "Ridge venting checked and balanced against soffit intake",
          "Magnetic yard sweep and full site clean-up",
        ],
      },
      {
        h2: "How long does a replacement take?",
        body: "Most Winnipeg homes — bungalows and standard two-storeys — are completed in one to three days, weather permitting. Larger or steeper roofs can take a day longer. We watch the forecast closely: a tear-off never starts when rain is likely, and if weather turns mid-job, the roof is dried-in and watertight before we leave, every single night.",
      },
      {
        h2: "What does a roof replacement cost in Winnipeg?",
        body: "Most homes land between $6,000 and $15,000. What moves the number: roof size and pitch, the number of old layers to tear off, deck repairs, shingle grade, and extras like skylights or complex valleys. That's why every Amiri quote follows a real on-roof and in-attic inspection — a price given from a satellite image is a guess you'll pay for later.",
      },
    ],
  },
  {
    slug: "roofing-contractor-winnipeg",
    seoTitle: "Roofing Contractor Winnipeg | How to Choose the Right One — Amiri Roofing",
    seoDesc:
      "How to choose a roofing contractor in Winnipeg: the questions to ask, red flags to avoid, and what a proper quote should include. Local crew, photo-documented work. 204-963-9081.",
    overline: "Choosing a Roofer — Winnipeg, MB",
    h1a: "Hire a contractor",
    h1b: "you can verify.",
    image: "crew",
    imageAlt: "Amiri Roofing crew member working on a Winnipeg residential roof",
    intro:
      "Winnipeg has no shortage of roofing contractors — and after every hailstorm, out-of-town crews knock on doors offering deals that evaporate with the next storm. Choosing well matters more than choosing fast: your roof is a 20-year decision, and the warranty is only as good as the company still answering its phone in five years. Here's how we'd evaluate any roofer — including us.",
    sections: [
      {
        h2: "Questions to ask before signing anything",
        body: "A trustworthy contractor answers every one of these without hesitating:",
        list: [
          "Will you physically get on the roof and into the attic before quoting?",
          "Can I see photos of what you find — and of every layer during the job?",
          "Is the quote itemized in writing, with materials and labour separated?",
          "Who is actually on my roof — your crew or subcontractors?",
          "Are you insured, and can you show a current certificate?",
          "What workmanship warranty do you provide, in writing?",
        ],
      },
      {
        h2: "Red flags Winnipeg homeowners should watch for",
        body: "Storm-chasing crews follow every major hail event into the city. Protect yourself:",
        list: [
          "Quotes given from the driveway or a satellite image, no inspection",
          "Pressure to sign today because a 'storm discount' expires",
          "Large deposits demanded up front before materials arrive",
          "No local address, or a phone number that routes out of province",
          "Refusal to provide a written, itemized contract",
        ],
      },
      {
        h2: "Why Winnipeg homeowners choose Amiri Roofing",
        body: "We're a local crew, not a franchise. Every quote starts with a real inspection — on the roof and in the attic — and every job is documented with photos from tear-off to final shingle. The person who quotes your roof is accountable for it, and our phone number reaches a human during business hours, hail season included. Compare us against anyone using the questions above; we're confident in the answers.",
      },
    ],
  },
  {
    slug: "residential-roofing-winnipeg",
    seoTitle: "Residential Roofing Winnipeg | Shingle Roofing for Homes — Amiri Roofing",
    seoDesc:
      "Residential roofing in Winnipeg: shingle installation, full replacement, repairs and inspections for houses, bungalows and garages. Local crew, free photo-documented quotes. 204-963-9081.",
    overline: "Residential Roofing — Winnipeg, MB",
    h1a: "Residential roofing",
    h1b: "for real Winnipeg homes.",
    image: "hip",
    imageAlt: "Aerial view of residential shingle roofs in a Winnipeg neighbourhood",
    intro:
      "Houses are all we do. No commercial flat roofs, no industrial jobs competing for our crew's time — just Winnipeg homes, from River Heights character houses to Sage Creek new builds. That focus matters: residential roofing is its own craft, with its own ventilation math, its own details around chimneys and dormers, and its own standard for how a property should look when the crew leaves.",
    sections: [
      {
        h2: "Every residential service, one standard",
        body: "From a single leaking vent to a full tear-off, the same rules apply: inspect properly, photograph everything, quote in writing, clean up completely.",
        list: [
          "Asphalt shingle roofing — architectural-grade, six-nail high-wind pattern",
          "Full roof replacement with deck inspection and rebuild",
          "Roof repairs and leak response, traced to the real source",
          "Storm and hail damage restoration with insurance-ready documentation",
          "Seasonal inspections and maintenance before freeze-up",
          "Ice dam removal and the ventilation fixes that prevent them",
        ],
      },
      {
        h2: "Built for Winnipeg's housing stock",
        body: "A 1920s Wolseley two-storey, a 1960s St. Vital bungalow, and a 2015 Bridgwater build have almost nothing in common under the shingles. Older homes often hide plank decking, undersized vents, and layers of history; newer homes often carry builder-grade shingles at the end of their short lives. We adjust the system — underlayment, flashing details, ventilation — to the house we actually find, not the one in a brochure.",
      },
      {
        h2: "Ventilation: the part of your roof you can't see",
        body: "Most premature roof failures in Manitoba trace back to the attic, not the shingles. Warm, moist air trapped under the deck cooks shingles from below in summer and builds frost in winter. Every Amiri inspection includes the attic: intake at the soffits, exhaust at the ridge, and insulation levels — because a new roof over a sick attic is money wasted.",
      },
    ],
  },
  {
    slug: "hail-damage-roof-repair-winnipeg",
    seoTitle: "Hail Damage Roof Repair Winnipeg | Insurance Claim Help — Amiri Roofing",
    seoDesc:
      "Hail damage roof repair in Winnipeg: free post-storm inspections, photo-documented insurance reports, emergency tarping and full restoration. Call 204-963-9081 after the storm.",
    overline: "Storm & Hail Response — Winnipeg, MB",
    h1a: "Hail hit?",
    h1b: "Here's the plan.",
    image: "brown",
    imageAlt: "Winnipeg home roof inspected for hail damage after a summer storm",
    intro:
      "Winnipeg sits in one of Canada's most active hail corridors, and every summer the radar lights up over the prairies. The tricky part about hail damage is that it rarely leaks right away — bruised shingles shed granules for months, and by the time the leak appears, the storm date is hard to prove. The single best move after a major hail event is a documented inspection while the evidence is fresh.",
    sections: [
      {
        h2: "What hail actually does to a roof",
        body: "Hail doesn't usually punch holes — it bruises. Knowing the signs helps you understand your inspection report:",
        list: [
          "Granule loss — dark bruises where protective granules were knocked off",
          "Cracked or fractured shingle matting under the surface",
          "Dented soft metals: vents, flashing, eavestroughs (the easy evidence adjusters trust)",
          "Damaged ridge caps and exposed nail heads",
          "Accelerated aging — a bruised roof can lose years of life without leaking yet",
        ],
      },
      {
        h2: "After the storm: what to do, in order",
        body: "The days after a hailstorm are when claims are won or lost:",
        list: [
          "Photograph hail on the ground next to a ruler or coin, and any visible damage from ground level",
          "Note the storm date and time — your insurer will ask",
          "Call us for a free inspection before filing: we'll tell you honestly if damage justifies a claim",
          "If it does, file with our photo report in hand — it shortens the back-and-forth dramatically",
          "Don't sign anything with door-knocking crews until your own inspection is done",
        ],
      },
      {
        h2: "How we work with your insurance claim",
        body: "We provide a photo-documented damage report formatted the way adjusters expect: roof diagrams, soft-metal evidence, and test squares. If shingles are discontinued, we document that too — it often means a full replacement is covered instead of a patch. Emergency tarping is available the same day when roofs are actively leaking. Once your claim is approved, the restoration is scheduled like any Amiri job: itemized, photographed, and cleaned up completely.",
      },
    ],
  },
  {
    slug: "emergency-roof-repair-winnipeg",
    seoTitle: "Emergency Roof Repair Winnipeg | Storm & Leak Response — Amiri Roofing",
    seoDesc:
      "Emergency roof repair in Winnipeg: active leaks, storm-torn shingles, emergency tarping and fast repairs. When your roof can't wait, call Amiri Roofing at 204-963-9081.",
    overline: "Emergency Roof Repair — Winnipeg, MB",
    h1a: "Roof emergency?",
    h1b: "Act fast, stay calm.",
    image: "crew",
    imageAlt: "Roofer responding to an emergency roof repair on a Winnipeg home",
    intro:
      "A branch through the shingles at 9pm. Water dripping through a light fixture during a storm. A section of roof peeled back by wind with rain on the way. Roof emergencies are stressful — but the first hour matters more than the panic. Contain the water inside, document what you can see safely from the ground, and get a tarp on the problem before it spreads into insulation, drywall, and flooring. That's exactly what our emergency response is built for.",
    sections: [
      {
        h2: "What counts as a roofing emergency",
        body: "If water is getting in — or about to — it's an emergency. Common urgent calls we respond to across Winnipeg:",
        list: [
          "Active leaks during or after a storm",
          "Shingles or roofing sections torn off by wind, exposing the deck",
          "Fallen tree branches puncturing the roof",
          "Ice dam flooding — water backing up under shingles in winter",
          "Flashing torn loose around chimneys or walls during high winds",
          "Any opening where rain or meltwater can enter before a permanent repair",
        ],
      },
      {
        h2: "What to do in the first hour",
        body: "Before you call anyone, protect your home and your insurance claim:",
        list: [
          "Move furniture and valuables away from the leak; put buckets down",
          "Photograph everything you can see safely — interior stains, debris in the yard, hail on the ground",
          "Never climb onto a wet, icy, or storm-damaged roof yourself",
          "Note the date and time of the storm — your insurer will ask",
          "Call 204-963-9081 — during storm events we prioritize active leaks and emergency tarping",
        ],
      },
      {
        h2: "How our emergency response works",
        body: "First we make it watertight: emergency tarping or a temporary dry-in so no more water enters — that same visit whenever conditions allow. Then we document the damage with photos formatted for insurance, give you a written price for the permanent repair, and schedule the work. You get one point of contact from the tarp to the final shingle, and your yard gets the same magnetic clean-up as any Amiri job.",
      },
    ],
  },
  {
    slug: "asphalt-shingle-roofing-winnipeg",
    seoTitle: "Asphalt Shingle Roofing Winnipeg | Installation & Replacement — Amiri Roofing",
    seoDesc:
      "Asphalt shingle roofing in Winnipeg: architectural shingle installation with high-wind nailing, ice-and-water shield and proper ventilation. Free quotes: 204-963-9081.",
    overline: "Asphalt Shingle Roofing — Winnipeg, MB",
    h1a: "Shingles built",
    h1b: "for Manitoba.",
    image: "brown",
    imageAlt: "Architectural asphalt shingles installed on a Winnipeg home by Amiri Roofing",
    intro:
      "Asphalt shingles cover most Winnipeg homes for good reason: they're the best value in roofing, and modern architectural shingles genuinely stand up to prairie weather — when they're installed for it. The shingle is only the visible layer. What makes it last here is the system underneath: shield coverage, nailing pattern, flashing, and ventilation sized for -40°C.",
    sections: [
      {
        h2: "Why architectural shingles for Winnipeg",
        body: "We install laminated architectural shingles, not basic 3-tab. The difference matters in this climate:",
        list: [
          "Heavier, thicker construction that resists wind lift",
          "Wind ratings up to 210 km/h with enhanced nailing patterns",
          "Impact-rated options (Class 3/4) for hail season",
          "Dimensional look that suits everything from River Heights character homes to new builds",
          "Manufacturer warranties that hold up when installed as a full system",
        ],
      },
      {
        h2: "Our installation standard",
        body: "Every Amiri shingle roof is built the same way, regardless of shingle price point:",
        list: [
          "Full tear-off to the deck — never roofing over old layers",
          "Ice-and-water shield past the interior wall line, plus valleys and penetrations",
          "Synthetic underlayment across the whole deck",
          "Six-nail high-wind fastening on every shingle",
          "New flashing and drip edge — old metal never reused",
          "Ridge ventilation balanced against soffit intake",
        ],
      },
      {
        h2: "How long should a shingle roof last here?",
        body: "A quality architectural shingle, properly installed and ventilated, should give a Winnipeg home 20–25 years. Roofs that fail at 10–12 almost always trace back to installation shortcuts or attic ventilation problems, not the shingle itself. That's why every quote we write starts with the attic, not the ladder.",
      },
    ],
  },
  {
    slug: "ice-dam-removal-winnipeg",
    seoTitle: "Ice Dam Removal & Prevention Winnipeg | Amiri Roofing",
    seoDesc:
      "Ice dam removal in Winnipeg: safe steam removal, damage repair, and the insulation and ventilation fixes that stop ice dams for good. Call 204-963-9081.",
    overline: "Ice Dams — Winnipeg, MB",
    h1a: "Ice dams removed.",
    h1b: "Then prevented.",
    image: "ridge",
    imageAlt: "Winnipeg roof with ridge ventilation that prevents winter ice dams",
    intro:
      "Every Winnipeg winter, the same cycle: snow melts over the warm part of your roof, refreezes at the cold eaves, and water backs up under the shingles into your ceiling. Chipping the ice off treats the symptom — and usually damages the roof doing it. We remove ice dams safely, repair the damage, and fix the heat loss that caused them.",
    sections: [
      {
        h2: "Why ice dams form on your roof specifically",
        body: "Ice dams are a building-science problem, not a snow problem. Three causes, often combined:",
        list: [
          "Attic heat loss — insulation below R-50 lets interior heat warm the roof deck",
          "Air leaks — pot lights, attic hatches and vent stacks leaking warm air upward",
          "Poor ventilation — blocked soffits or undersized ridge vents trapping warm air",
        ],
      },
      {
        h2: "Safe removal, not chipping",
        body: "Axes, hammers and pressure washers destroy shingles and void warranties. We use low-pressure steam to cut channels and remove dams without touching the roof surface, then document any damage underneath for your records or insurer. If water is actively entering your home, call 204-963-9081 — active leaks get priority during winter weather events.",
      },
      {
        h2: "The permanent fix",
        body: "Removal buys a season; prevention ends the cycle. After any removal we show you photos of the attic conditions and give you a plain-language plan: insulation top-up, air sealing at the usual leak points, and ventilation balancing. Homes that complete this work simply don't get ice dams the following winter.",
      },
    ],
  },
  {
    slug: "roof-inspection-winnipeg",
    seoTitle: "Roof Inspection Winnipeg | Free Photo-Documented Inspections — Amiri Roofing",
    seoDesc:
      "Roof inspections in Winnipeg: on-roof and in-attic assessment with photos, plain-language findings and honest recommendations. Free with every quote: 204-963-9081.",
    overline: "Roof Inspections — Winnipeg, MB",
    h1a: "Know exactly what's",
    h1b: "over your head.",
    image: "crew",
    imageAlt: "Amiri Roofing inspector examining a Winnipeg residential roof",
    intro:
      "Most roof problems give years of warning — if anyone looks. A proper inspection isn't a glance from the driveway or a drone photo; it's boots on the roof and a head in the attic. Every Amiri quote starts with one, and it's free: you get photos and a straight answer whether you hire us or not.",
    sections: [
      {
        h2: "What our inspection covers",
        body: "Two halves of the same system, checked every time:",
        list: [
          "On the roof: shingle condition, granule loss, valleys, flashing, vents, chimneys, ridge caps",
          "In the attic: daylight, moisture staining, mould, insulation depth, ventilation airflow",
          "Documentation: photos of everything, in plain language",
          "Verdict: repair, monitor, or replace — with the reasoning shown, not just stated",
        ],
      },
      {
        h2: "When Winnipeg homeowners should book one",
        body: "Five moments when an inspection pays for itself:",
        list: [
          "Every fall, before freeze-up locks problems in for five months",
          "After any major hail or wind storm — even without visible damage",
          "Before buying or selling a home",
          "When the roof passes 15 years of age",
          "Any time a ceiling stain, drip, or shingle in the yard appears",
        ],
      },
      {
        h2: "What you receive",
        body: "A photo-documented summary of your roof's condition, remaining life estimate, and — only if work is actually needed — an itemized written quote. If your roof is fine, we say so and leave. That policy is why Winnipeg homeowners call us back years later when the roof genuinely is due.",
      },
    ],
  },
  {
    slug: "attic-ventilation-winnipeg",
    seoTitle: "Attic & Roof Ventilation Winnipeg | Amiri Roofing",
    seoDesc:
      "Roof and attic ventilation in Winnipeg: ridge vents, soffit intake and airflow balancing that prevents ice dams, attic frost and premature shingle failure. 204-963-9081.",
    overline: "Attic Ventilation — Winnipeg, MB",
    h1a: "Your roof fails",
    h1b: "from underneath first.",
    image: "hip",
    imageAlt: "Winnipeg homes with properly ventilated residential roofing systems",
    intro:
      "The part of your roof that decides how long it lasts is the part you can't see from the curb. Attic ventilation controls the temperature and moisture under your roof deck — and in Manitoba's climate, getting it wrong cooks shingles in summer, grows frost in winter, and feeds every ice dam on the street.",
    sections: [
      {
        h2: "Signs your ventilation is failing",
        body: "These symptoms almost always trace back to airflow, not shingles:",
        list: [
          "Ice dams forming along the eaves every winter",
          "Frost or moisture on attic nails and sheathing in January",
          "Upstairs rooms that bake in summer",
          "Shingles curling or aging unevenly across slopes",
          "Mould staining in the attic or a musty smell upstairs",
        ],
      },
      {
        h2: "How a balanced system works",
        body: "Ventilation is intake plus exhaust — one without the other does nothing. Cool air enters at the soffits, travels along the underside of the deck, and exits at the ridge, carrying heat and moisture with it. Blocked soffits are the most common failure we find in Winnipeg homes: insulation drifted over the intake, strangling the whole system.",
      },
      {
        h2: "How we fix it",
        body: "Every ventilation job starts in the attic with measurements, not guesses. Depending on what we find: clearing and baffling soffit intakes, adding or resizing ridge venting, sealing attic air leaks, and coordinating with insulation depth. The work is unglamorous and inexpensive compared to what it prevents — and it's included in every Amiri inspection at no charge.",
      },
    ],
  },
];

export const SERVICE_PAGE_LINKS = {
  "asphalt-shingles": "/asphalt-shingle-roofing-winnipeg",
  "roof-replacement": "/roof-replacement-winnipeg",
  "roof-repair": "/roof-repair-winnipeg",
  "storm-hail": "/hail-damage-roof-repair-winnipeg",
  inspections: "/roof-inspection-winnipeg",
  "winter-damage": "/ice-dam-removal-winnipeg",
  "gutter-cleaning": "/roof-inspection-winnipeg",
};

export const FAQS = [
  {
    q: "How much does a roof replacement cost in Winnipeg?",
    a: "Most Winnipeg homes fall between $6,000 and $15,000 depending on size, pitch, layers to tear off, and shingle choice. We give one written, itemized price after a real on-roof inspection — no vague allowances or surprise extras.",
  },
  {
    q: "How long does a roof replacement take?",
    a: "Most homes are completed in 1–3 days, weather permitting. We finish with a full magnetic sweep of your yard so not a single nail is left behind.",
  },
  {
    q: "Do you help with insurance claims for hail damage?",
    a: "Yes. After a storm we provide a photo-documented damage report your insurer can actually use, emergency tarping if needed, and full restoration once your claim is approved.",
  },
  {
    q: "What shingles work best for Manitoba winters?",
    a: "Laminated architectural shingles with high-wind nailing, ice-and-water shield past the interior wall line, and proper attic ventilation. That combination handles -40°C cold snaps, freeze-thaw cycles, and 120 km/h gusts.",
  },
  {
    q: "Do you offer free roof inspections in Winnipeg?",
    a: "Yes — every quote starts with a free on-roof and in-attic inspection across Winnipeg and surrounding areas. You get photos of everything we find, whether you hire us or not. Call 204-963-9081.",
  },
];

export const MARQUEE_ITEMS = [
  "Asphalt Shingles",
  "Roof Replacement",
  "Storm & Hail Repair",
  "Leak Response",
  "Ice Dam Removal",
  "Gutter Cleaning",
  "Free Inspections",
  "Winnipeg, Manitoba",
];

export const GBP_URL = "https://maps.app.goo.gl/PVqFGeS7vPqk4Ydi6?g_st=ic";

export const POSTS = [
  {
    slug: "prevent-ice-dams-winnipeg",
    title: "How to Prevent Ice Dams: A Winnipeg Homeowner's Guide",
    seoTitle: "How to Prevent Ice Dams in Winnipeg | Amiri Roofing",
    excerpt:
      "Ice dams aren't a snow problem — they're a heat-loss problem. Here's how Winnipeg homeowners can stop them before January.",
    date: "2026-07-08",
    readTime: "4 min read",
    image: "ridge",
    imageAlt: "Winnipeg roof with proper ridge ventilation that helps prevent ice dams",
    sections: [
      {
        h2: "What an ice dam actually is",
        body: "An ice dam forms when heat escaping from your house melts snow on the upper roof. The meltwater runs down to the cold eaves, refreezes, and builds a ridge of ice. Water then pools behind that ridge and works its way under the shingles — into your attic, insulation, and ceilings. In Winnipeg, where we swing between -30°C nights and sunny melt days, the conditions are perfect for it.",
      },
      {
        h2: "The three real causes",
        body: "Ice dams are almost never a shingle problem. They trace back to three fixable issues:",
        list: [
          "Attic heat loss — under-insulated attics (below R-50) warm the roof deck from below",
          "Air leaks — gaps around pot lights, attic hatches, and plumbing stacks dump warm air into the attic",
          "Poor ventilation — blocked soffits or undersized ridge vents trap warm air where it does the most damage",
        ],
      },
      {
        h2: "Your pre-winter prevention checklist",
        body: "The best ice dam fix happens in October, not February:",
        list: [
          "Have attic insulation checked and topped up toward R-50",
          "Seal attic air leaks around lights, hatches, and vent stacks",
          "Confirm soffit intake and ridge exhaust are clear and balanced",
          "Clear eavestroughs so meltwater has somewhere to go",
          "Ask for ice-and-water shield coverage at eaves when re-roofing",
        ],
      },
      {
        h2: "If you already have an ice dam",
        body: "Don't chip at it with an axe or ice pick — you'll damage the shingles and it's genuinely dangerous on an icy roof. Safe removal uses low-pressure steam, and the permanent fix is the insulation and ventilation work above. If water is actively entering the house, treat it as an emergency and call a roofer before the next melt.",
      },
    ],
  },
  {
    slug: "fall-roof-prep-winnipeg",
    title: "Fall Roof Prep: 7 Things to Do Before Winnipeg's First Freeze",
    seoTitle: "Fall Roof Prep Checklist for Winnipeg Homes | Amiri Roofing",
    excerpt:
      "Once the freeze hits, small roof problems lock in for five months. A September checklist that saves Winnipeg homeowners thousands.",
    date: "2026-07-15",
    readTime: "4 min read",
    image: "hip",
    imageAlt: "Winnipeg neighbourhood roofs prepared for the Manitoba winter season",
    sections: [
      {
        h2: "Why fall matters more than any other season",
        body: "Manitoba winters don't forgive. A lifted shingle in October becomes a leak in January; a blocked vent in November becomes attic frost by February. Roofing work also gets harder and more limited once temperatures drop — shingles need warmth to seal properly. Fall is your last easy window.",
      },
      {
        h2: "Your pre-freeze checklist",
        body: "Seven things to check before the snow flies:",
        list: [
          "Shingles — look for curling, cracking, or missing tabs from summer storms",
          "Flashing — inspect around chimneys, skylights, and where walls meet the roof",
          "Vent boots — rubber boots crack in our cold; a $30 part causes expensive leaks",
          "Attic ventilation — confirm soffits are clear of insulation and debris",
          "Overhanging branches — trim anything rubbing or dropping debris on the roof",
          "Caulking and sealants — cold makes old sealant brittle; check penetrations",
          "Book a professional inspection — attic included — while weather still allows",
        ],
      },
      {
        h2: "What a professional fall inspection covers",
        body: "A proper inspection goes beyond a glance from the driveway: on the roof we check every slope, valley, vent, and flashing detail; in the attic we check for daylight, moisture staining, mould, insulation depth, and airflow. You get photos of everything, in plain language, whether anything needs doing or not. It's the cheapest roof insurance available in Winnipeg.",
      },
    ],
  },
  {
    slug: "hail-season-winnipeg-guide",
    title: "Hail Season in Winnipeg: What to Do Before and After the Storm",
    seoTitle: "Winnipeg Hail Season Guide for Homeowners | Amiri Roofing",
    excerpt:
      "Winnipeg sits in one of Canada's most active hail corridors. How to prepare, what to document, and how claims actually get approved.",
    date: "2026-07-22",
    readTime: "5 min read",
    image: "brown",
    imageAlt: "Winnipeg home roof inspected after a summer hailstorm",
    sections: [
      {
        h2: "When hail season hits Winnipeg",
        body: "Most Winnipeg hail arrives between June and August, riding the same prairie thunderstorm systems that bring our dramatic summer skies. Damage is rarely obvious from the ground — hail bruises shingles rather than punching through them — which is why so many claims fail: by the time a leak appears, the storm date is hard to prove.",
      },
      {
        h2: "Before the storm",
        body: "A little preparation makes any future claim much smoother:",
        list: [
          "Know your roof's age and last inspection date — keep records",
          "Photograph your roof and property in good condition once a year",
          "Review your insurance policy's hail coverage and deductible",
          "Keep a local roofer's number saved: 204-963-9081",
        ],
      },
      {
        h2: "After the storm",
        body: "The days right after hail are when claims are won or lost:",
        list: [
          "Photograph hail stones next to a ruler or coin before they melt",
          "Note the exact date and time of the storm",
          "Get a professional inspection BEFORE filing — know if damage justifies a claim",
          "Document soft metals: dented vents, flashing and eavestroughs are trusted evidence",
          "Don't sign with door-knocking crews until your own inspection is done",
        ],
      },
      {
        h2: "Why documentation wins claims",
        body: "Adjusters approve claims with evidence, not adjectives. A proper storm report includes roof diagrams, test squares, and soft-metal photos formatted the way insurers expect. If your shingle is discontinued, that documentation matters too — it often means a full replacement is covered instead of a patch. We prepare this report as part of every hail inspection, free with your quote.",
      },
    ],
  },
  {
    slug: "roof-replacement-cost-winnipeg",
    title: "How Much Does a Roof Replacement Cost in Winnipeg?",
    seoTitle: "Roof Replacement Cost in Winnipeg (2026 Guide) | Amiri Roofing",
    excerpt:
      "What actually moves the price of a new roof in Winnipeg — size, pitch, layers, materials — and how to read a quote so there are no surprises.",
    date: "2026-07-29",
    readTime: "5 min read",
    image: "hero",
    imageAlt: "Newly replaced architectural shingle roof on a Winnipeg home",
    sections: [
      {
        h2: "The honest price range",
        body: "Most Winnipeg homes fall between $6,000 and $15,000 for a full replacement with quality architectural shingles. Smaller bungalows with simple rooflines sit at the low end; large two-storeys with steep pitches, valleys, and dormers sit higher. Any quote given without an on-roof inspection is a guess — treat it that way.",
      },
      {
        h2: "What actually moves the price",
        body: "Six factors decide where your home lands in that range:",
        list: [
          "Roof size and pitch — steeper roofs mean more safety rigging and slower work",
          "Layers to tear off — older Winnipeg homes sometimes hide two or three",
          "Deck condition — soft or rotten wood must be replaced before roofing",
          "Material grade — standard vs. premium architectural shingles",
          "Complexity — valleys, dormers, skylights, and chimneys all add labour",
          "Ventilation upgrades — ridge venting or added intake where needed",
        ],
      },
      {
        h2: "How to read a roofing quote",
        body: "A proper quote is itemized in writing: tear-off, deck work, underlayment, ice-and-water shield coverage, flashing, shingles, ventilation, and clean-up — each as its own line. Vague allowances and 'as needed' clauses are where surprise costs hide. Ask every contractor the same question: what exactly is NOT included? The honest ones answer immediately.",
      },
      {
        h2: "Why the cheapest quote usually isn't",
        body: "The difference between a 12-year roof and a 25-year roof is almost entirely in the parts you can't see from the curb: underlayment, shield coverage at the eaves, nailing pattern, flashing, and ventilation. A quote that's $2,000 lower often means ice-and-water shield only at the minimum code line, four-nail fastening, or reused flashing — shortcuts that show up as leaks in year three. Compare scope line by line, not just totals.",
      },
    ],
  },
  {
    slug: "best-shingles-manitoba-winters",
    title: "The Best Roofing Shingles for Manitoba Winters",
    seoTitle: "Best Shingles for Manitoba Winters | Amiri Roofing Winnipeg",
    excerpt:
      "Not every shingle survives -40°C and 120 km/h gusts. What actually matters when choosing shingles for a Winnipeg roof.",
    date: "2026-08-05",
    readTime: "4 min read",
    image: "brown",
    imageAlt: "Close aerial view of architectural asphalt shingles on a Winnipeg roof",
    sections: [
      {
        h2: "What Manitoba winters demand from a shingle",
        body: "A Winnipeg roof endures conditions most shingle marketing never mentions: -40°C cold snaps, rapid freeze-thaw cycles, summer hail, and straight-line prairie winds. The shingle that survives all four is a laminated architectural shingle — heavier, thicker, and wind-rated far beyond the basic 3-tab products of the past.",
      },
      {
        h2: "What to look for when choosing",
        body: "Forget brand loyalty for a moment — these specifications matter more:",
        list: [
          "Architectural (laminated) construction — never basic 3-tab for our climate",
          "High wind rating — look for ratings up to 210 km/h with enhanced nailing",
          "Class 3 or Class 4 impact rating — meaningful protection in hail season",
          "Strong algae resistance — important for shaded, tree-covered streets",
          "A warranty backed by proper installation — most warranties require specific system components",
        ],
      },
      {
        h2: "The installation matters more than the shingle",
        body: "The best shingle installed poorly fails before an average shingle installed well. Six-nail high-wind patterns, ice-and-water shield past the interior wall line, sealed valleys, and balanced attic ventilation do more for winter survival than any shingle upgrade. When comparing quotes, ask each contractor exactly how they nail, where shield goes, and how they ventilate — the answers tell you everything.",
      },
    ],
  },
  {
    slug: "choose-best-roofing-company-winnipeg",
    title: "How to Choose the Best Roofing Company in Winnipeg",
    seoTitle: "Best Roofing Company in Winnipeg: How to Choose | Amiri Roofing",
    excerpt:
      "A step-by-step buyer's guide to hiring a roofer in Winnipeg — the checklist, the questions, and the proof that separates real contractors from door-knockers.",
    date: "2026-08-12",
    readTime: "5 min read",
    image: "crew",
    imageAlt: "Professional roofer inspecting a Winnipeg home roof during a quote",
    sections: [
      {
        h2: "Start with proof, not promises",
        body: "Every roofing company in Winnipeg claims to be the best. None of that matters. What matters is evidence you can check yourself: a real local presence, insurance you can verify, reviews you can read, and a quoting process that involves actually looking at your roof. The best companies welcome scrutiny — the rest change the subject.",
      },
      {
        h2: "The 7-point checklist",
        body: "Score every company you talk to against these seven points:",
        list: [
          "Local address and history — not a truck that appeared after the last hailstorm",
          "Current liability insurance and WCB coverage, shown on request",
          "A real on-roof and in-attic inspection before any price is given",
          "A written, itemized quote — materials and labour separated, no vague allowances",
          "A workmanship warranty in writing, with a company that will exist to honour it",
          "Photo documentation of findings and of the finished work",
          "Verifiable Google reviews from real Winnipeg homeowners",
        ],
      },
      {
        h2: "Five questions that reveal everything",
        body: "Ask these verbatim and listen to how quickly and specifically each company answers:",
        list: [
          "Who will physically be on my roof — your crew or subcontractors?",
          "Where exactly does ice-and-water shield go on my home?",
          "How do you handle deck rot you find mid-job — and at what price?",
          "What is your clean-up process, including nails in my yard?",
          "If something leaks in year four, what happens?",
        ],
      },
      {
        h2: "The bottom line",
        body: "The best roofing company for your home is the one whose quote you can verify line by line, whose reviews you can read, and whose phone a human answers. Get two or three quotes, run every company through this checklist, and the right choice usually makes itself obvious. And yes — we built Amiri Roofing to pass this exact test, so hold us to it: 204-963-9081.",
      },
    ],
  },
  {
    slug: "roof-leak-repair-winnipeg",
    title: "Roof Leak Repair in Winnipeg: Find It, Fix It, Stop It Coming Back",
    seoTitle: "Roof Leak Repair Winnipeg | Find & Fix Leaks Fast — Amiri Roofing",
    excerpt:
      "Where roof leaks actually start (rarely where the stain appears), what a real repair involves, and how to keep the same leak from returning.",
    date: "2026-08-19",
    readTime: "4 min read",
    image: "ridge",
    imageAlt: "Ridge and valley area of a Winnipeg roof inspected for leak sources",
    sections: [
      {
        h2: "The stain is never where the leak is",
        body: "Water travels. It enters at a vent, valley or flashing point, runs along a rafter or the underside of the deck, and drips onto your ceiling metres away. That's why patch-where-it-drips repairs fail: they fix the symptom's location, not the source. Proper leak repair starts in the attic with a flashlight, tracing staining uphill to the entry point.",
      },
      {
        h2: "Where Winnipeg roofs actually leak",
        body: "After freeze-thaw cycles and prairie storms, the same culprits show up again and again:",
        list: [
          "Plumbing vent boots — rubber cracks in extreme cold",
          "Chimney and wall flashing — sealant fails, metal lifts",
          "Valleys — the highest water volume anywhere on the roof",
          "Ice dam backup at eaves every winter",
          "Nail pops and wind-lifted shingle edges after storms",
          "Skylight curbs and old satellite dish mounts",
        ],
      },
      {
        h2: "What a real repair includes",
        body: "A lasting repair means lifting the surrounding shingles, replacing damaged underlayment and deck if needed, installing new flashing or components, and re-sealing the system — then photographing everything so you have proof of what was done. If the same area has been 'repaired' twice already, that's the roof telling you the source was never found, or the roof is telling the truth about its age. Either way, you deserve the honest version.",
      },
    ],
  },
  {
    slug: "how-long-does-roof-last-manitoba",
    title: "How Long Does a Roof Last in Manitoba? The Honest Numbers",
    seoTitle: "How Long Does a Roof Last in Manitoba? | Amiri Roofing Winnipeg",
    excerpt:
      "Manufacturer labels say 30–50 years. Manitoba weather disagrees. What actually determines roof lifespan here — and how to get every year you're owed.",
    date: "2026-08-26",
    readTime: "4 min read",
    image: "hip",
    imageAlt: "Aerial view of Winnipeg residential roofs of varying ages and conditions",
    sections: [
      {
        h2: "The honest numbers",
        body: "Basic 3-tab shingles: 12–15 years in Manitoba, whatever the package says. Quality architectural shingles properly installed: 20–25 years. Premium systems with upgraded underlayment and ventilation: pushing 30. The gap between the brochure number and the Winnipeg number is our climate — freeze-thaw cycling, hail, and UV exposure at prairie intensity.",
      },
      {
        h2: "What actually decides your roof's lifespan",
        body: "More than the shingle brand, four things determine how many winters you get:",
        list: [
          "Installation quality — nailing pattern, flashing, shield coverage",
          "Attic ventilation — the silent killer of otherwise good roofs",
          "Storm history — hail years take years off a roof's life",
          "Maintenance — annual checks catch $200 problems before they're $8,000 problems",
        ],
      },
      {
        h2: "How to know where your roof stands",
        body: "Age is a starting point, not a verdict. A 16-year-old roof in good condition may have five good years left; a 10-year-old roof installed poorly may be done. The only reliable answer comes from an on-roof inspection with attic access — granule loss, shingle flexibility, flashing condition and ventilation tell the real story. Ours are free and photo-documented, so you can see what we see: 204-963-9081.",
      },
    ],
  },
];
